/* eslint-disable react/prop-types */
// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonAvatar from "components/ArgonAvatar";
import ArgonButton from "components/ArgonButton";

import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";

import { Link } from "react-router-dom";

const ProductTableData = (products, handleDeleteClick, refreshData) => ({
  columns: [
    { name: "sno", align: "center" },
    { name: "Product Name", align: "left" },
    { name: "Subtitle", align: "left" },
    { name: "Image Banner", align: "left" },
    { name: "Price Normal", align: "center" },
    { name: "MRP", align: "center" },
    { name: "Discount Price", align: "center" },
    { name: "Avg Rating", align: "center" },
    { name: "Rating Count", align: "center" },
    { name: "Action", align: "center" },
  ],

  rows: products.map((product, index) => ({
    sno: (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {index + 1}
      </ArgonTypography>
    ),
    "Product Name": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {product.productName || "N/A"}
      </ArgonTypography>
    ),
    Subtitle: (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {product.subtitle || "N/A"}
      </ArgonTypography>
    ),
    "Image Banner": (
      <ArgonAvatar
        src={product.imageBanner}
        alt={product.productName || "Product"}
        size="sm"
        variant="rounded"
      />
    ),
    "Price Normal": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        ₹{product.priceNormal || 0}
      </ArgonTypography>
    ),
    MRP: (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        ₹{product.MRP || 0}
      </ArgonTypography>
    ),
    "Discount Price": (
      <ArgonTypography variant="caption" color="success" fontWeight="medium">
        ₹{product.discountPrice || 0}
      </ArgonTypography>
    ),
    "Avg Rating": (
      <ArgonTypography variant="caption" color="warning" fontWeight="medium">
        {product.AvgRating ? `⭐ ${product.AvgRating.toFixed(1)}` : "N/A"}
      </ArgonTypography>
    ),
    "Rating Count": (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {product.RatingCount || 0}
      </ArgonTypography>
    ),
    Action: (
      <ArgonBox display="flex" alignItems="center" gap={0}>
        {/* Edit Icon */}
        <ArgonButton
          variant="text"
          size="large"
          component={Link}
          to={`/product/editproduct/${product._id}`}
          sx={{ minWidth: "32px", p: 0 }}
        >
          <VisibilityIcon color="primary" />
        </ArgonButton>
        {/* Delete Icon */}
        <ArgonButton
          variant="text"
          size="large"
          sx={{ minWidth: "32px", p: 0 }}
          onClick={() => handleDeleteClick(product._id)}
        >
          <DeleteIcon color="error" />
        </ArgonButton>
      </ArgonBox>
    ),
  })),
});

export default ProductTableData;
